























































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '../models/event';

@Component
export default class EventInfoPlaceAddressComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;
}
